import React from 'react';

// Helper function to get a date in YYYY-MM-DD format based on the user's local timezone
const getLocalDateString = (date) => {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
};

const ProfileSummary = ({ milkRecords, healthRecords, feedRecords, onViewDetails }) => {
    // --- CALCULATIONS ---

    // 1. Filter records for the last 7 days and for today
    const sevenDaysAgo = new Date();
    sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);
    const todayStr = getLocalDateString(new Date());

    const milkRecords7Days = milkRecords.filter(r => new Date(r.date) >= sevenDaysAgo);
    const healthRecords7Days = healthRecords.filter(r => new Date(r.date) >= sevenDaysAgo);
    const feedRecords7Days = feedRecords.filter(r => new Date(r.date) >= sevenDaysAgo);
    
    const milkRecordsToday = milkRecords.filter(r => r.date === todayStr);
    const healthRecordsToday = healthRecords.filter(r => r.date === todayStr);
    const feedRecordsToday = feedRecords.filter(r => r.date === todayStr);

    // 2. Calculate 7-Day Totals
    const totalMilk7Days = milkRecords7Days.reduce((sum, rec) => sum + (rec.morningYield || 0) + (rec.eveningYield || 0), 0);
    const milkIncome7Days = milkRecords7Days.reduce((sum, rec) => {
        const dailyYield = (rec.morningYield || 0) + (rec.eveningYield || 0);
        return sum + (dailyYield * (rec.pricePerLiter || 0));
    }, 0);
    const healthCost7Days = healthRecords7Days.reduce((sum, rec) => sum + (Number(rec.cost) || 0), 0);
    const feedCost7Days = feedRecords7Days.reduce((sum, rec) => sum + (rec.cost || 0), 0);
    const totalExpense7Days = healthCost7Days + feedCost7Days;
    const netProfit7Days = milkIncome7Days - totalExpense7Days;

    // 3. Calculate Today's Totals
    const totalMilkToday = milkRecordsToday.reduce((sum, rec) => sum + (rec.morningYield || 0) + (rec.eveningYield || 0), 0);
    const totalExpenseToday = healthRecordsToday.reduce((sum, rec) => sum + (Number(rec.cost) || 0), 0) + feedRecordsToday.reduce((sum, rec) => sum + (rec.cost || 0), 0);
    const milkIncomeToday = milkRecordsToday.reduce((sum, rec) => {
        const dailyYield = (rec.morningYield || 0) + (rec.eveningYield || 0);
        return sum + (dailyYield * (rec.pricePerLiter || 0));
    }, 0);
    const netProfitToday = milkIncomeToday - totalExpenseToday;

    return (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {/* CARD 1: Milk Production */}
            <div onClick={() => onViewDetails('milk_details')} className="bg-white p-6 rounded-lg shadow hover:shadow-lg transition-shadow cursor-pointer flex flex-col justify-between">
                <div>
                    <p className="text-xs text-gray-500">Today: {totalMilkToday.toFixed(1)} L</p>
                    <h3 className="text-lg font-semibold text-gray-900 mt-1">Total Milk Production</h3>
                </div>
                <div>
                    <p className="text-3xl font-bold text-blue-600 mt-2">{totalMilk7Days.toFixed(1)} L</p>
                    <p className="text-sm text-gray-500">Last 7 Days</p>
                </div>
            </div>

            {/* CARD 2: Total Expenses */}
            <div className="bg-white p-6 rounded-lg shadow flex flex-col justify-between">
                <div>
                    <p className="text-xs text-gray-500">Today: ₹{totalExpenseToday.toFixed(2)}</p>
                    <h3 className="text-lg font-semibold text-gray-900 mt-1">Total Expenses</h3>
                </div>
                <div>
                    <p className="text-3xl font-bold text-red-600 mt-2">{`₹${totalExpense7Days.toFixed(2)}`}</p>
                    <p className="text-sm text-gray-500">Last 7 Days</p>
                </div>
            </div>

            {/* CARD 3: Net Profit */}
            <div className="bg-white p-6 rounded-lg shadow flex flex-col justify-between">
                <div>
                    <p className="text-xs text-gray-500">Today: ₹{netProfitToday.toFixed(2)}</p>
                    <h3 className="text-lg font-semibold text-gray-900 mt-1">Net Profit</h3>
                </div>
                <div>
                    <p className={`text-3xl font-bold mt-2 ${netProfit7Days >= 0 ? 'text-green-600' : 'text-red-600'}`}>
                        {`₹${netProfit7Days.toFixed(2)}`}
                    </p>
                    <p className="text-sm text-gray-500">Last 7 Days</p>
                </div>
            </div>
        </div>
    );
};

export default ProfileSummary;